import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function YearMonthCalendar({
  type = "month",
  name = "",
  value = "",
  title = "",
  onChange,
  isError = false,
  errorText = " ",
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker", "DatePicker", "DatePicker"]}>
        <DatePicker
          onChange={(e) => {
            onChange(e, name);
          }}
          sx={{ overflow: "hidden" }}
          label={title}
          value={value}
          format={"MM/YYYY"}
          views={["month", "year"]}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "standard",
              error: isError,
              helperText: errorText,
              //   value: value,
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}